<ion-header class="ion-align-items-center ion-no-border">
  <ion-toolbar color="primary">
    <page-title
      title="Export Results"
      icon="grid"
      iconColor="light"
      iconSize="small"
      titleColor="light"
      [titleSize]="14"
      class="ion-margin-horizontal ion-padding-horizontal"
    >
      <span class="flex"></span>
      <ion-button fill="clear" class="button-icon" (click)="modal.dismiss()" color="light">
        <ion-icon slot="icon-only" name="close"> </ion-icon>
      </ion-button>
    </page-title>
  </ion-toolbar>
</ion-header>

<ion-grid class="body">
  <analytics-header
    class="ion-padding-vertical"
    (ionChangeFilters)="changeFilters($event)"
    [emitOnChange]="true"
    [dialogView]="true"
    [start]="startDate"
    [end]="endDate"
    [compareResults]="compareResults!"
    [filterBy]="filterBy!"
    [socials]="socials && socials.length ? socials : []"
    [comparison]="comparison!"
    [startCompareCustom]="startDateCompare"
    [endCompareCustom]="endDateCompare"
  >
    <div class="ly-col flex">
      <ion-label>
        {{ 'components.analyticsHeader.labels.exportType' | translate }}
      </ion-label>

      <ion-row class="flex ion-padding-top flex-wrap checkbox-group">
        <ion-item *ngFor="let value of ['excel', 'csv', 'email']" class="flex">
          <ion-checkbox [(ngModel)]="$any(this)[value + 'Checked']" color="success"> </ion-checkbox>
          <p
            class="ion-margin-start"
            [class.ion-text-capitalize]="value === 'excel' || value === 'email'"
            [class.ion-text-uppercase]="value === 'csv'"
          >
            {{ value }}
          </p>
        </ion-item>
      </ion-row>
    </div>
  </analytics-header>
</ion-grid>

<div class="md-actions ion-padding-bottom outer">
  <ion-button color="medium" (click)="modal.dismiss()" class="ion-margin-right">
    {{ 'cancelText' | translate }}
  </ion-button>

  <ion-button
    (click)="export()"
    [promiseBtn]="exportPromise"
    [disabled]="!csvChecked && !emailChecked && !excelChecked"
  >
    {{ 'saveText' | translate }}
  </ion-button>
</div>
